/** Decodes HTML entities in a string (e.g. &lt;a&gt; → <a>). */
export function decodeHtml(str: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}
